// constants for deployment

// uncomment the one you use, must end with slash

// export const DATA_SOURCE_URL = 'http://127.0.0.1:3000/data/';
export const DATA_SOURCE_URL = 'https://h0lland.pythonanywhere.com/data/';

export const AUTH_ENABLED = true;
